import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration (ENV-ONLY). No hardcoded fallbacks.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
} as const;

const requiredKeys = [
  firebaseConfig.apiKey,
  firebaseConfig.authDomain,
  firebaseConfig.projectId,
  firebaseConfig.storageBucket,
  firebaseConfig.messagingSenderId,
  firebaseConfig.appId,
];

const hasAllEnv = requiredKeys.every(Boolean);

// Initialize Firebase only when all env vars are present
let app: any = null;
let auth: any = null;
let db: any = null;
let storage: any = null;

if (hasAllEnv) {
  app = initializeApp(firebaseConfig as any);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  console.log('[Firebase] Initialized with environment variables');
} else {
  // eslint-disable-next-line no-console
  console.error('[Firebase] Missing required environment variables. Auth and DB disabled until vars are set.');
}

// Initialize Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Keep provider available even if not configured (caller should gate by isFirebaseConfigured)

// Export Firebase services
export { auth, db, storage, googleProvider };
export default app;

// Export a flag to indicate if Firebase is configured
export const isFirebaseConfigured = hasAllEnv;
